<template>
      <div
        :class="`service ${serviceStyle} ${checkTextAlign}`"
        data-aos="fade-up"
        data-aos-delay="70"
        :id="service.id"
      >
        <div class="icon">
          <Icon
            :name="service.icon"
            :class="`size-${iconSize}`"
          />
          <h3 class="title w-600 mx-3">{{ service.title }}</h3>
        </div>
        <div class="content">
          <p
            class="description b1 color-gray mb--0"
            v-html="service.description"
          />
          <Button
            v-if="service.readMore"
            :read-more-button="service.readMore.readMoreButton"
            :url="`/services/${service.id}`"
            title="Read More"
          />
        </div>
      </div>
</template>

<script>
    import Button from '../button/Button'
    import Icon from '../../icon/Icon'
    export default {
        name: 'ServiceCard',
        components: {Button, Icon},
        props: {
            iconSize: {
                type: [String, Number],
                default: 62
            },
            service: {},
            serviceStyle: {
                type: String
            },
            textAlign: {
                type: String,
                default: 'left'
            }
        },
        computed: {
            checkTextAlign() {
                if (this.textAlign === 'left') return 'text-start';
                else if (this.textAlign === 'center') return 'text-center';
                else if (this.textAlign === 'end') return 'text-end';
                else return '';
            }
        }
    }
</script>
